(() => {
  const button = document.querySelector('[data-pdp-back-to-top]');
  if (!button) return;

  const threshold = () => window.innerHeight * 0.75;
  let visible = false;

  const reveal = () => {
    if (visible) return;
    visible = true;
    button.hidden = false;
    requestAnimationFrame(() => button.classList.add('is-visible'));
  };

  const hide = () => {
    if (!visible) return;
    visible = false;
    button.classList.remove('is-visible');
    setTimeout(() => {
      if (!visible) button.hidden = true;
    }, 300);
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      if (window.scrollY > threshold()) reveal();
      else hide();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  button.addEventListener('click', () => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
  });
})();
